import cms from './cms';

const DATA_STORE_KEY = 'email-marketing-campaign';

export interface EmailMarketingCampaignItem {
  title: string;
  status: boolean;
  priceId: string;
  description: string;
}

export type EmailMarketingCampaignData = Record<
  string,
  EmailMarketingCampaignItem
>;

export async function getEmailMarketingCampaigns(): Promise<EmailMarketingCampaignData> {
  try {
    const response = await cms.get<EmailMarketingCampaignData>(
      `/v2/data-store/${DATA_STORE_KEY}`
    );
    const data = response.data ?? {};
    return typeof data === 'object' && !Array.isArray(data) ? data : {};
  } catch (error) {
    console.error('Error fetching email marketing campaigns:', error);
    throw new Error(
      'No se pudieron cargar las campañas. Intenta de nuevo más tarde.'
    );
  }
}
